import {Component, OnInit, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {FilterDrawerService} from '../../../services/filter-drawer.service';

@Component({
  selector: 'app-filter-drawer-header',
  templateUrl: './filter-drawer-header.component.html',
  styleUrls: ['./filter-drawer-header.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
})
export class FilterDrawerHeaderComponent {
  filterDrawerService = inject(FilterDrawerService);
}
